import { createApi } from "@reduxjs/toolkit/query/react";
import customFetchBaseQuery from "./customFetchBaseQuery";

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: customFetchBaseQuery,
  tagTypes: ["Reports", "Monitor", "Statuses"],
  endpoints: () => ({}),
});
